<div class="content">
  <h2>Canvas Editor</h2>
  <span class="hint">
    <i class="fa-solid fa-info-circle"></i> The current map view will be used as the default. Adjust the map to change it.
  </span>
  <motn-canvas-editor
    [tileId]="tileId"
    [imageUrl]="canvasImageUrl"
    [canvasPoints]="canvasStructure?.Points || []"
    [clusterEnabled]="clusterEnabled"
    [initialView]="$safeNavigationMigration(canvasStructure?.InitialView)"
    (canvasPointsChange)="onCanvasPointsChange($event)"
    (imageChange)="onImageChange($event)"
    (clusterChange)="onClusterChange($event)"
    (initialViewChange)="onInitialViewChange($event)"
  ></motn-canvas-editor>
</div>
